<template>
  <div class="sharing-page">
    <!-- 顶部导航栏 -->
    <header class="sharing-header" :style="{paddingTop: statusBarHeight + 'px'}">
      <div class="header-background">
        <img src="@/assets/sharing/headbackground.png" alt="背景" class="header-bg-img" />
      </div>
      <div class="header-nav">
        <div class="nav-back-wrapper">
          <button class="nav-back-btn" @click="goBack">
            <i class="el-icon-arrow-left"></i>
          </button>
        </div>
        <div class="nav-title">安心家庭</div>
        <div style="width: 28px;"></div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="sharing-content" :style="{paddingTop: pageContentTop + 'px'}">
      <!-- 主宣传区域 -->
      <div class="promo-section">
        <div class="promo-left">
          <h1 class="promo-title">
            <span class="title-black">加入家庭空间</span><span class="title-green">守护家人健康</span>
          </h1>
          <p class="promo-subtitle">与家人和亲朋好友分享健康状态，让关爱零距离~</p>
        </div>
        <div class="promo-right">
          <img src="@/assets/serviceImg/gxsjtotu.png" alt="家庭空间" class="promo-image" />
        </div>
      </div>

      <!-- 功能卡片区域 -->
      <div class="cards-section">
        <!-- 绑定紧急联系人卡片 -->
        <div class="feature-card">
          <div class="card-icon-wrapper">
            <img src="@/assets/sharing/bind.png" alt="绑定紧急联系人" class="card-icon" />
          </div>
          <div class="card-content">
            <h3 class="card-title">绑定紧急联系人</h3>
            <p class="card-description">您可以选择添加紧急联系人，健康异常提醒通知给家人朋友</p>
          </div>
        </div>

        <!-- 接受重要提醒卡片 -->
        <div class="feature-card">
          <div class="card-icon-wrapper">
            <img src="@/assets/sharing/reminder.png" alt="接受重要提醒" class="card-icon" />
          </div>
          <div class="card-content">
            <h3 class="card-title">接受重要提醒</h3>
            <p class="card-description">紧急联系人可以通过手机短信接收与家人健康相关的重要提醒</p>
          </div>
        </div>
      </div>

      <!-- 添加紧急联系人按钮 -->
      <div class="action-button-wrapper">
        <button class="add-contact-btn" @click="actionEmergencyContact">
          添加紧急联系人
        </button>
      </div>
    </div>

    <!-- 权益弹窗 -->
    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <span class="close" @click="showModal = false">&times;</span>
        <p style="margin-bottom: 7vw;">该项权益需开通以下服务权益</p>
        <div style="width:100%;height:40vw;position: relative;" @click="equity()">
          <img style="width: 100%;height: 100%;position: absolute;top: 2vw;" src="@/assets/img/qykbj.png" />
          <div>
             <h3 style="position: absolute;top: 17vw;left: 7vw;font-size: 5vw;">大救星-星健康权益卡</h3>
             <div style="position: absolute;top: 25vw;left: 7vw;color:#666666;font-size: 3.5vw;">多项健康权益尊享，为您健康守护</div>
             <div style="width: 18vw;height: 7vw;font-size: 3vw;line-height: 7vw;color: #F2D57A;text-align: center;background: rgb(74, 71, 64);border-radius: 16px;position: absolute;top: 17vw;right: 4vw;">了解更多</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global';

export default {
  name: 'Sharing',
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight', 'pageContentTop', 'pageBackBtnTop'])
  },
  data() {
    return {
      showModal: false,
      equityinfoType: false
    };
  },
  mounted() {
    if (localStorage.getItem('oldAge') == 1) {
      document.getElementById("html").style.fontSize = "48px";
    }
  },
  created() {
    this.equityinfoType = localStorage.getItem('equityinfo');
  },
  beforeCreate() {
    document.title = "安心家庭";
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F2F3F5");
  },
  methods: {
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },
    
    /**
     * 添加紧急联系人
     */
    actionEmergencyContact() {
      if (this.equityinfoType == false || this.equityinfoType == 'false') {
        this.showModal = true;
      } else {
        this.$router.push({
              path: "/contacts",
              query:{
              }
            });
        // window.location.href = 'appdjxhealth://actionEmergencyContact';
      }
    },
    
    /**
     * 跳转到权益页面
     */
    equity() {
      this.$router.push({
        path: "/equity",
        query: {}
      });
    }
  }
};
</script>

<style scoped lang="less">
.sharing-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #E8F5E9 0%, #FFFFFF 100%);
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

/* 顶部导航栏 */
.sharing-header {
  position: relative;
  width: 100%;
  min-height: 220px;
  overflow: hidden;
  margin-bottom: 0;
}

.header-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.header-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.header-nav {
  position: relative;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  min-height: 44px;
}

.nav-back-wrapper {
  flex-shrink: 0;
}

.nav-back-btn {
  width: 28px;
  height: 28px;
  padding: 0;
  background: #ffffff;
  border: none;
  border-radius: 50%;
  color: #000000;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.nav-back-btn i {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}

.nav-back-btn:hover {
  background: #f5f5f5;
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.nav-back-btn:active {
  transform: translateY(0) scale(0.95);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.nav-title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  max-width: calc(100% - 120px);
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #000000;
}

/* 内容区域 */
.sharing-content {
  width: 100%;
  padding: 20px 16px 20px;
  position: absolute;
  top: 0;
  z-index: 10;
}

/* 主宣传区域 */
.promo-section {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  padding: 0 4px;
}

.promo-left {
  flex: 1;
  min-width: 0;
}

.promo-title {
  margin: 0 0 12px 0;
  line-height: 1.4;
  display: block;
}

.title-black {
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  line-height: 1.4;
}

.title-green {
  font-size: 20px;
  font-weight: 600;
  color: #00C275;
  line-height: 1.4;
}

.promo-subtitle {
  font-size: 11px;
  color: #666666;
  line-height: 1.5;
  margin: 0;
}

.promo-right {
  flex-shrink: 0;
  width: 140px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.promo-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 功能卡片区域 */
.cards-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
}

.feature-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #F0F0F0;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  height: 86px;
  transition: all 0.3s ease;
  
  &:active {
    transform: scale(0.98);
    background: #F8F9FA;
  }
}

.card-icon-wrapper {
  flex-shrink: 0;
  width: 60px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.card-content {
  flex: 1;
  min-width: 0;
}

.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #000000;
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.card-description {
  font-size: 11px;
  color: #666666;
  line-height: 1.5;
  margin: 0;
}

/* 添加紧急联系人按钮 */
.action-button-wrapper {
  padding: 16px 0;
  margin-top: 20px;
}

.add-contact-btn {
  width: 100%;
  height: 48px;
  background: url('~@/assets/sharing/add.png') no-repeat center center;
  background-size: 100% 100%;
  border: none;
  border-radius: 0;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }
  
  &:active {
    transform: scale(0.98);
    opacity: 0.95;
  }
}

/* 权益弹窗 */
.modal {
  position: fixed;
  z-index: 1000000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  padding: 8% 5%;
  border-radius: 12px 12px 0px 0px;
  position: absolute;
  bottom: 0;
  width: 100%;
  line-height: 0;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
}

/* 响应式设计 */
@media (max-width: 375px) {
  .promo-title {
    gap: 2px;
  }
  
  .title-black,
  .title-green {
    font-size: 20px;
  }
  
  .promo-subtitle {
    font-size: 11px;
  }
  
  .promo-right {
    width: 120px;
    height: 120px;
  }
  
  .card-title {
    font-size: 15px;
  }
  
  .card-description {
    font-size: 11px;
  }
  
  .add-contact-btn {
    height: 44px;
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/detailsH5/sharing.vue